import { useQuery } from '@tanstack/react-query'
import { getSwitchJobTelemetry } from '../api/switchlists'

/**
 * Execution telemetry hook (Plan 26 Phase 1a; ADR-002/ADR-007).
 * Server state keyed on [facilityId, workOrderId] — the row is immutable per
 * revision, so a normal stale time is fine; recompute bumps
 * generation_version and callers can invalidate on 'workorders'.
 *
 * Returns `null` data for 404 (no telemetry row, or the row isn't in the
 * caller's facility scope) — the UI renders "Telemetry Summary Unavailable"
 * rather than an error state.
 */
export function useSwitchJobTelemetry(
  facilityId: string | undefined,
  workOrderId: string | undefined
) {
  return useQuery({
    queryKey: ['switch-job-telemetry', facilityId ?? '', workOrderId ?? ''] as const,
    queryFn: () => getSwitchJobTelemetry(workOrderId!),
    enabled: !!facilityId && !!workOrderId,
    // Ledger rows are append-only — a returned revision never changes.
    staleTime: 60_000,
  })
}
